/* eslint-disable @typescript-eslint/no-explicit-any */
import { t } from "i18next";

import React from "react";

export default function NodataFound({
    colSpanLength,
}: {
    colSpanLength: number;
}): JSX.Element {
    return (
        <tr
            style={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "300px",
                background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
                height: "100%",
            }}
        >
            <td
                colSpan={colSpanLength}
                style={{
                    textAlign: "center",
                    width: "100%",
                    padding: "3rem",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "1.5rem",
                }}
            >
                {/* Animated Empty State Icon */}
                <div
                    style={{
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    {/* Background Circle */}
                    <div
                        style={{
                            width: "120px",
                            height: "120px",
                            borderRadius: "50%",
                            background:
                                "linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            position: "relative",
                            animation:
                                "emptyStatePulse 3s ease-in-out infinite",
                        }}
                    >
                        {/* Animated rings */}
                        <div
                            style={{
                                position: "absolute",
                                top: "-10px",
                                left: "-10px",
                                right: "-10px",
                                bottom: "-10px",
                                border: "2px solid transparent",
                                borderTop: "2px solid #94a3b8",
                                borderRadius: "50%",
                                animation:
                                    "emptyStateRotate 4s linear infinite",
                            }}
                        />

                        {/* Search/Database Icon */}
                        <svg
                            width="48"
                            height="48"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#64748b"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            style={{
                                animation:
                                    "emptyStateFloat 2s ease-in-out infinite",
                            }}
                        >
                            <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                            <path d="m21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path>
                            <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>
                        </svg>

                        {/* Floating dots */}
                        <div
                            style={{
                                position: "absolute",
                                top: "20px",
                                right: "15px",
                                width: "6px",
                                height: "6px",
                                backgroundColor: "#77dff8",
                                borderRadius: "50%",
                                animation:
                                    "emptyStateDot 2s ease-in-out infinite 0.5s",
                            }}
                        />
                        <div
                            style={{
                                position: "absolute",
                                bottom: "25px",
                                left: "20px",
                                width: "4px",
                                height: "4px",
                                backgroundColor: "#93c5fd",
                                borderRadius: "50%",
                                animation:
                                    "emptyStateDot 2s ease-in-out infinite 1s",
                            }}
                        />
                        <div
                            style={{
                                position: "absolute",
                                top: "35px",
                                left: "30px",
                                width: "5px",
                                height: "5px",
                                backgroundColor: "#a78bfa",
                                borderRadius: "50%",
                                animation:
                                    "emptyStateDot 2s ease-in-out infinite 1.5s",
                            }}
                        />
                    </div>
                </div>

                {/* Title */}
                <div
                    style={{
                        fontSize: "var(--font-size-body)",
                        fontWeight: "600",
                        color: "#374151",
                        marginBottom: "0.5rem",
                    }}
                >
                    {t("No data found")}
                </div>

                {/* Description */}
                <div
                    style={{
                        fontSize: "var(--font-size-base)",
                        color: "#6b7280",
                        lineHeight: "1.5",
                        maxWidth: "400px",
                    }}
                >
                    {t(
                        "There are no items to display at the moment. Data will appear here when available."
                    )}
                </div>
            </td>

            {/* CSS Animations */}
            <style>{`
        @keyframes emptyStatePulse {
            0%, 100% { 
                transform: scale(1);
                opacity: 0.8;
            }
            50% { 
                transform: scale(1.05);
                opacity: 1;
            }
        }
        
        @keyframes emptyStateRotate {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
        
        @keyframes emptyStateFloat {
            0%, 100% { 
                transform: translateY(0px);
            }
            50% { 
                transform: translateY(-8px);
            }
        }
        
        @keyframes emptyStateDot {
            0%, 100% { 
                transform: translateY(0px);
                opacity: 0.6;
            }
            50% { 
                transform: translateY(-12px);
                opacity: 1;
            }
        }
    `}</style>
        </tr>
    );
}
